export default __webpack_public_path__ + "static/media/ao-dai-gd837bc657_640.1a0183bd.jpg";